export enum FormNameDocumentEnum {
    agents = 'agents',
}